const localStoragePrefix = "memo-";
export default localStoragePrefix;
